import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BookingTabs from './BookingTabs';
import { adminAction } from '../../../../redux/common/action';
import VehicleDetailsCard from './VehicleDetailsCard';
import VehicleForm from './VehicleForm';
import axios from 'axios';
import { toast } from 'react-toastify';
import { URL as COMMON_URL } from '../../../../redux/common/url';
import { Modal, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { AsyncPaginate } from 'react-select-async-paginate';
import moment from 'moment';
import ReactPaginate from 'react-paginate'; // Added for pagination
import { Loader } from '@googlemaps/js-api-loader';

function VehicleBooking() {
  const dispatch = useDispatch();
  const [vehicle, setVehicle] = useState<any>(null); // Store the full vehicle object from VehicleForm
  const [fromDate, setFromDate] = useState<any>('');
  const [toDate, setToDate] = useState<any>('');
  const [activeTab, setActiveTab] = useState<any>('Pending');
  const bookings = useSelector((state: any) => state.admin.vehicle_bookings_list?.data || []);
  const total = useSelector((state: any) => state.admin.vehicle_bookings_list?.total || 0); // For pagination

  // Pagination state
  const [pageNo, setPageNo] = useState<number>(1);
  const [pageCount, setPageCount] = useState<number>(0);

  // Circle / Manager / Vendor filters
  const [circles, setCircles] = useState<any[]>([]);
  const [circle_id, setCircle_id] = useState('');

  const [seleceteMangerXenForFilters, setseleceteMangerXenForFilters] = useState<any>({});
  const [seleceteMangerAenForFilters, setseleceteMangerAenForFilters] = useState<any>({});
  const [seleceteMangerJenForFilters, setseleceteMangerJenForFilters] = useState<any>({});

  const [vendorId, setVendorId] = useState<string>('');
  const [jenId, setJenId] = useState<any>(null);
  // keys to reset AsyncPaginate
  const [managerKey, setManagerKey] = useState(0);
  const [managerKeyAen, setManagerKeyAen] = useState(0);
  const [managerKeyJen, setManagerKeyJen] = useState(0);
  const [vendorKey, setVendorKey] = useState(0);
  const [vehicleKey, setVehicleKey] = useState(0);



  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState<any>(null);
  // ==================== BULK BOOKING STATES ====================
const [selectedBookingIds, setSelectedBookingIds] = useState<number[]>([]);
const [showBulkModal, setShowBulkModal] = useState(false);
const [bulkDate, setBulkDate] = useState(new Date());
const [bulkFillingImage, setBulkFillingImage] = useState<File | null>(null);
const [bulkDestinationVideo, setBulkDestinationVideo] = useState<File | null>(null);
const [bulkSubmitting, setBulkSubmitting] = useState(false);

  const [acceptedTime, setAcceptedTime] = useState<string>("");
  const [completeTime, setCompleteTime] = useState<string>("");
  const [fillingImage, setFillingImage] = useState<File | null>(null);
  const [destinationImage, setDestinationImage] = useState<File | null>(null);
  const [fillingVideo, setFillingVideo] = useState<File | null>(null);
  const [destinationVideo, setDestinationVideo] = useState<File | null>(null);
  const [previewImage, setPreviewImage] = useState<{ [key: string]: string }>({});
  const [fileStatus, setFileStatus] = useState<{ [key: string]: string }>({});
  const [startDate, setStartDate] = useState(new Date());
  const [selectedSource, setSelectedSource] = useState<any>({});
  const [selectedVehicle, setSelectedVehicle] = useState<any>({}); // For modal editing
  const [selectedDestination, setSelectedDestination] = useState<any>({});
  const [totalDistance, setTotalDistance] = useState<string>('');
  const [watermarkText, setWatermarkText] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleSubmit = (values: any) => {
    const { vehicle, fromdate, todate } = values;
    setVehicle(vehicle); // Store the full vehicle object
    setFromDate(fromdate);
    setToDate(todate);
    setPageNo(1); // Reset to first page
    dispatch(adminAction.getVehicleBookings({ vehicle: vehicle.value, status: 'Pending', fromdate: fromdate || '', todate: todate || '', page: 1 }));
  };

  useEffect(() => {
    if (vehicle?.value) {
      dispatch(adminAction.getVehicleBookings({
        vehicle: vehicle.value,
        status: activeTab,
        fromdate: fromDate || '',
        todate: toDate || '',
        page: pageNo
      }));
    }
  }, [vehicle?.value, activeTab, pageNo, dispatch]);


  // Update page count when total changes
  useEffect(() => {
    if (total > 0) {
      setPageCount(Math.ceil(total / 500)); // Assuming 50 per page
    }
  }, [total]);

  useEffect(() => {
    fetchCircles();
  }, []);

  const fetchCircles = async () => {
    try {
      const res = await axios.get(`${COMMON_URL.API_BASE_URL}${COMMON_URL.getAllCircles}`);
      if (res?.data?.data) {
        setCircles(res.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };


  // Pagination handler
  const handlePageClick = (event: any) => {
    const selectedPage = event.selected + 1;
    setPageNo(selectedPage);
  };

  // ==================== BULK BOOKING SELECTION ====================

// ==================== BULK BOOKING SELECTION ====================

const handleBookingSelection = (
  bookingId: number,
  checked: boolean
) => {
  setSelectedBookingIds((prev) => {
    if (checked) {
      if (prev.includes(bookingId)) {
        return prev;
      }

      return [...prev, bookingId];
    }

    return prev.filter((id) => id !== bookingId);
  });
};

const handleSelectAllBookings = (checked: boolean) => {
  if (checked) {
    const currentPageIds = bookings
      .map((booking: any) => Number(booking.id))
      .filter((id: number) => id > 0);

    setSelectedBookingIds((prev) => {
      return Array.from(
        new Set([...prev, ...currentPageIds])
      );
    });
  } else {
    const currentPageIds = new Set(
      bookings.map((booking: any) => Number(booking.id))
    );

    setSelectedBookingIds((prev) =>
      prev.filter((id) => !currentPageIds.has(id))
    );
  }
};

const allCurrentPageSelected =
  bookings.length > 0 &&
  bookings.every((booking: any) =>
    selectedBookingIds.includes(Number(booking.id))
  );

  // ==================== BULK COMPLETE BOOKING ====================

const handleOpenBulkModal = () => {
  if (selectedBookingIds.length === 0) {
    toast.error('Please select at least one booking');
    return;
  }

  if (!vehicle?.value) {
    toast.error('Please select a vehicle');
    return;
  }

  setBulkDate(new Date());
  setBulkFillingImage(null);
  setBulkDestinationVideo(null);

  setShowBulkModal(true);
};


const handleCloseBulkModal = () => {
  if (bulkSubmitting) {
    return;
  }

  setShowBulkModal(false);
  setBulkFillingImage(null);
  setBulkDestinationVideo(null);
};


const handleCompleteBulkBooking = async () => {
  if (selectedBookingIds.length === 0) {
    toast.error('Please select at least one booking');
    return;
  }

  if (!vehicle?.value) {
    toast.error('Vehicle is required');
    return;
  }

  if (!bulkDate) {
    toast.error('Date is required');
    return;
  }

  try {
    setBulkSubmitting(true);

    const authToken = localStorage.getItem(
      'kt-auth-react-v'
    );

    if (!authToken) {
      toast.error('Authentication token not found');
      return;
    }

    const token = JSON.parse(authToken);

    const formData = new FormData();

    // ids[]
    selectedBookingIds.forEach((id) => {
      formData.append('ids[]', String(id));
    });

    // vehicle
    formData.append(
      'vehicle',
      String(vehicle.value)
    );

    // date
    formData.append(
      'date',
      moment(bulkDate).format(
        'YYYY/MM/DD hh:mm A'
      )
    );

    // filling image
    if (bulkFillingImage) {
      formData.append(
        'filling_image',
        bulkFillingImage
      );
    }

    // destination video
    if (bulkDestinationVideo) {
      formData.append(
        'destination_video',
        bulkDestinationVideo
      );
    }

    const config = {
      headers: {
        Authorization:
          'Bearer ' + token.api_token,
        'Content-Type': 'multipart/form-data',
      },
    };

    const response = await axios.post(
      `${COMMON_URL.API_BASE_URL}${COMMON_URL.completeBulkBooking}`,
      formData,
      config
    );

    if (response?.data?.data) {
      toast.success(
        response?.data?.message ||
        'Bookings completed successfully'
      );

      // Close modal
      setShowBulkModal(false);

      // Clear selection
      setSelectedBookingIds([]);

      // Clear files
      setBulkFillingImage(null);
      setBulkDestinationVideo(null);

      // Reload current report
      dispatch(
        adminAction.getVehicleBookings({
          vehicle: vehicle.value,
          status: activeTab,
          fromdate: fromDate || '',
          todate: toDate || '',
          page: pageNo,
        })
      );
    }

  } catch (error: any) {
    console.error(
      'Bulk booking error:',
      error
    );

    toast.error(
      error?.response?.data?.message ||
      'Error completing bulk bookings'
    );

  } finally {
    setBulkSubmitting(false);
  }
};

  const handleEditClick = (booking: any) => {
    setTotalDistance('');
    setSelectedBooking(booking);
    setAcceptedTime(booking?.accepted_time || "");
    setCompleteTime(booking?.complete_time || "");
    setStartDate(new Date(booking.date));
    setSelectedSource({
      value: booking.source_hydrant_center?.id,
      label: booking.source_hydrant_center?.address,
      latitude: booking.source_hydrant_center?.latitude,
      longitude: booking.source_hydrant_center?.longitude,
    });
    setSelectedVehicle({
      value: booking.vehicle?.id,
      label: booking.vehicle?.registration_number,
    });
    setSelectedDestination({
      value: booking.destination?.id,
      label: booking.destination?.address,
      latitude: booking.destination?.latitude,
      longitude: booking.destination?.longitude,
    });
    setFillingImage(null);
    setDestinationImage(null);
    setFillingVideo(null);
    setDestinationVideo(null);
    setPreviewImage({
      fillingImage: booking?.filling_image ? `${COMMON_URL.API_BASE_URL}${booking.filling_image}` : '',
      destinationImage: booking?.destination_image ? `${COMMON_URL.API_BASE_URL}${booking.destination_image}` : '',
      fillingVideo: booking?.filling_video ? `${COMMON_URL.API_BASE_URL}${booking.filling_video}` : '',
      destinationVideo: booking?.destination_video ? `${COMMON_URL.API_BASE_URL}${booking.destination_video}` : '',
    });
    setFileStatus({
      fillingImage: booking?.filling_image ? `Uploaded: ${booking.filling_image.split('/').pop()}` : '',
      destinationImage: booking?.destination_image ? `Uploaded: ${booking.destination_image.split('/').pop()}` : '',
      fillingVideo: booking?.filling_video ? `Uploaded: ${booking.filling_video.split('/').pop()}` : '',
      destinationVideo: booking?.destination_video ? `Uploaded: ${booking.destination_video.split('/').pop()}` : '',
    });


   // ==================== GENERATE WATERMARK TEXT (CHANGE 2) ====================
    const driverName = booking?.driver?.name || "";
    const formattedDate = moment(booking?.accepted_time).format('ddd MMM DD HH:mm:ss [GMT]Z YYYY');
    const lat = booking?.source_hydrant_center?.latitude || 0;
    const lon = booking?.source_hydrant_center?.longitude || 0;

    const text = `${driverName}\n${formattedDate}\n ${lat}\n${lon}`;
    setWatermarkText(text);

    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedBooking(null);
    setTotalDistance('');
  };

  const handleStartDateChange = (date: any) => {
    setStartDate(date);
  };

  const calculateRouteDistance = async () => {
    if (!selectedSource?.latitude || !selectedDestination?.latitude) return;

    const loader = new Loader({
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
      version: 'weekly',
    });

    try {
      await loader.load();

      const service = new google.maps.DistanceMatrixService();

      service.getDistanceMatrix(
        {
          origins: [
            new google.maps.LatLng(
              selectedSource.latitude,
              selectedSource.longitude
            ),
          ],
          destinations: [
            new google.maps.LatLng(
              selectedDestination.latitude,
              selectedDestination.longitude
            ),
          ],
          travelMode: google.maps.TravelMode.DRIVING,
          unitSystem: google.maps.UnitSystem.METRIC,
        },
        (response, status) => {
          if (status === 'OK') {
            const meters =
              response?.rows[0]?.elements[0]?.distance?.value || 0;
            const km = meters / 1000;
            setTotalDistance(km.toFixed(1));
          } else {
            toast.error('Failed to calculate distance');
          }
        }
      );
    } catch (err) {
      toast.error('Google Maps error');
    }
  };

  useEffect(() => {
    if (selectedSource?.value && selectedDestination?.value) {
      calculateRouteDistance();
    }
  }, [selectedSource, selectedDestination]);


// ==================== WATERMARK FUNCTION (CHANGE 3) ====================
  // Used for Filling Image upload in Edit Booking
  const generateWatermark = async (imageFile: File) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;

    const img = new window.Image();
    img.src = URL.createObjectURL(imageFile);

    await new Promise((resolve) => {
      img.onload = resolve;
    });

    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);

    // Watermark data
    const lines = watermarkText.split('\n');
    const name = lines[0] || '';
    const date = lines[1] || '';
    const lat = lines[2] || '';
    const long = lines[3] || '';

    ctx.fillStyle = '#F71512';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;

    const topFontSize = Math.max(canvas.width * 0.027, 19);
    const bottomFontSize = Math.max(canvas.width * 0.027, 19);
    const marginLeft = 20;

    ctx.font = `bold ${topFontSize}px Arial`;
    ctx.fillText(`Name: ${name}`, marginLeft, 24);

    ctx.font = `bold ${bottomFontSize}px Arial`;
    const lineHeight = bottomFontSize + 15;
    const startY = canvas.height - (lineHeight * 3) - 2;

    // Full GMT format (Mon Apr 27 13:47:00 GMT+05:30 2026)
    const acceptedFormatted = moment(acceptedTime).format('ddd MMM DD HH:mm:ss [GMT]Z YYYY');

    ctx.fillText(`Date: ${acceptedFormatted}`, marginLeft, startY);
    ctx.fillText(`Lat: ${lat}`, marginLeft, startY + lineHeight);
    ctx.fillText(`Long: ${long}`, marginLeft, startY + (lineHeight * 2));

    return new Promise<File>((resolve) => {
      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(new File([blob], imageFile.name, { type: 'image/jpeg' }));
          }
        },
        'image/jpeg',
        1
      );
    });
  };


  const loadOptionsgetManagerXenForFilters = async (
    search: any,
    loadedOptions: any,
    { page }: any
  ) => {
    if (!circle_id) return { options: [], hasMore: false }

    const token: any = localStorage.getItem('kt-auth-react-v')

    const response = await fetch(
      `${COMMON_URL.API_BASE_URL}/api/admins/get_all_xen?search=${search}&page=${page}&circle_id=${circle_id}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token!).api_token}`,
        },
      }
    )

    const responseJSON = await response.json()

    return {
      options: responseJSON?.results?.map((d: any) => ({
        ...d,
        value: d.id,
        label: d.name,
      })) || [],
      hasMore: responseJSON.has_more,
      additional: { page: page + 1 },
    }
  }

  const loadOptionsgetManagerAenForFilters = async (
    search: any,
    loadedOptions: any,
    { page }: any
  ) => {
    if (!seleceteMangerXenForFilters?.id) {
      return { options: [], hasMore: false }
    }

    const token: any = localStorage.getItem('kt-auth-react-v')

    const response = await fetch(
      `${COMMON_URL.API_BASE_URL}/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerXenForFilters.id}&circle_id=${circle_id}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token!).api_token}`,
        },
      }
    )

    const responseJSON = await response.json()

    return {
      options: responseJSON?.results?.map((d: any) => ({
        ...d,
        value: d.id,
        label: d.name,
      })) || [],
      hasMore: responseJSON.has_more,
      additional: { page: page + 1 },
    }
  }

  const loadOptionsgetManagerJenForFilters = async (
    search: any,
    loadedOptions: any,
    { page }: any
  ) => {
    if (!seleceteMangerAenForFilters?.id) {
      return { options: [], hasMore: false }
    }

    const token: any = localStorage.getItem('kt-auth-react-v')

    const response = await fetch(
      `${COMMON_URL.API_BASE_URL}/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerAenForFilters.id}&circle_id=${circle_id}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token!).api_token}`,
        },
      }
    )

    const responseJSON = await response.json()

    return {
      options: responseJSON?.results?.map((d: any) => ({
        ...d,
        value: d.id,
        label: d.name,
      })) || [],
      hasMore: responseJSON.has_more,
      additional: { page: page + 1 },
    }
  }

  // const loadOptionsVendor = async (search: any, loadedOptions: any, { page }: any) => {
  //   const token: any = localStorage.getItem('kt-auth-react-v');

  //   let url = `${COMMON_URL.getVendorList}?circle_id=${circle_id}`;
  //   if (seleceteMangerJenForFilters?.id) {
  //     url += `&jen_id=${seleceteMangerJenForFilters.id}`;
  //   }

  //   const response = await fetch(
  //     `${COMMON_URL.API_BASE_URL + url}&page=${page}&search=${search}`,
  //     {
  //       headers: {
  //         Authorization: `Bearer ${JSON.parse(token!).api_token}`,
  //       },
  //     }
  //   );

  //   const responseJSON = await response.json();

  //   return {
  //     options: responseJSON?.results?.map((v: any) => ({
  //       value: v.id,
  //       label: v.name,
  //     })) || [],
  //     hasMore: responseJSON.has_more,
  //     additional: { page: page + 1 },
  //   };
  // };


  const loadOptionsgetManagerJen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');
    const response = await fetch(`${COMMON_URL.API_BASE_URL}/api/admins/getSource?search=${search}&page=${page}&jen_id=${selectedBooking?.user?.jen_id || JSON.parse(token)?.data?.id}`, {
      headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` },
    });
    const responseJSON: any = await response.json();
    const options = responseJSON?.results?.map((data: any) => ({
      value: data?.id,
      label: data?.station_name || data?.address,
      latitude: data?.latitude,
      longitude: data?.longitude,
    }));
    return { options, hasMore: responseJSON.has_more, additional: { page: page + 1 } };
  };

  const loadOptionsgetManagerVehicle = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');
    const response = await fetch(`${COMMON_URL.API_BASE_URL}/api/admins/all_vehicle_jen?search=${search}&page=${page}&jen_id=${selectedBooking?.user?.jen_id || JSON.parse(token)?.data?.id}`, {
      headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` },
    });
    const responseJSON: any = await response.json();
    const options = responseJSON?.results?.map((data: any) => ({
      value: data?.id,
      label: data?.registration_number,
    }));
    return { options, hasMore: responseJSON.has_more, additional: { page: page + 1 } };
  };

  const loadOptionsgetManagerUser = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');
    const response = await fetch(`${COMMON_URL.API_BASE_URL}/api/admins/user_destinations?search=${search}&page=${page}&user_id=${selectedBooking?.user_id}`, {
      headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` },
    });
    const responseJSON: any = await response.json();
    const options = responseJSON?.results?.map((data: any) => ({
      value: data?.id,
      label: data?.address,
      latitude: data?.latitude,
      longitude: data?.longitude,
    }));
    return { options, hasMore: responseJSON.has_more, additional: { page: page + 1 } };
  };

  // ==================== IMAGE PREVIEW WITH WATERMARK (CHANGE 4) ====================
 const handleImagePreview = async (file: File, field: string) => {

  if (field === "fillingImage" && watermarkText) {

    const watermarkedFile = await generateWatermark(file);

    // IMPORTANT:
    // store watermarked file for upload
    setFillingImage(watermarkedFile);

    const watermarkedUrl = URL.createObjectURL(watermarkedFile);

    setPreviewImage((prev) => ({
      ...prev,
      fillingImage: watermarkedUrl,
    }));

    return;
  }

  const url = URL.createObjectURL(file);

  setPreviewImage((prev) => ({
    ...prev,
    [field]: url,
  }));
};

  const uploadProps = (setFile: (file: File | null) => void, isImage: boolean, field: string) => ({
    beforeUpload: (file: File) => {
      const isValidType = isImage ? file.type.startsWith('image/') : file.type.startsWith('video/');
      if (!isValidType) {
        toast.error(`Please upload a valid ${isImage ? 'image' : 'video'} file`);
        setFileStatus((prev) => ({ ...prev, [field]: 'Failed' }));
        return false;
      }
      setFile(file);
      setFileStatus((prev) => ({ ...prev, [field]: `Uploaded: ${file.name}` }));
      if (isImage) handleImagePreview(file, field);
      return false;
    },
    fileList: [],
  });

  const handleBooking = async () => {
    if (!selectedBooking?.id) {
      toast.error("Please select a booking to update");
      return;
    }

    try {
      const token = JSON.parse(localStorage.getItem('kt-auth-react-v')!);
      const config = {
        headers: {
          Authorization: 'Bearer ' + token.api_token,
          'Content-Type': 'multipart/form-data',
        },
      };

      const formData = new FormData();
      formData.append('booking_id', selectedBooking.id.toString());
      formData.append('accepted_time', moment(acceptedTime).format('YYYY-MM-DD hh:mm A') || '');
      formData.append('complete_time', moment(completeTime).format('YYYY-MM-DD hh:mm A') || '');
      formData.append('date', moment(startDate).format('YYYY/MM/DD hh:mm A'));
      formData.append('source_hydrant_center', selectedSource.value || '');
      formData.append('vehicle', selectedVehicle.value || '');
      formData.append('destination', selectedDestination.value || '');
      formData.append('total_distance', totalDistance || '');
      if (fillingImage) formData.append('filling_image', fillingImage);
      if (destinationImage) formData.append('destination_image', destinationImage);
      if (fillingVideo) formData.append('filling_video', fillingVideo);
      if (destinationVideo) formData.append('destination_video', destinationVideo);

      const res = await axios.post(`${COMMON_URL.API_BASE_URL}${COMMON_URL.completeBooking}`, formData, config);

      if (res?.data?.data) {
        toast.success(res?.data?.message);
        handleCloseEditModal();
        dispatch(adminAction.getVehicleBookings({
          vehicle: vehicle?.value,
          status: activeTab,
          fromdate: fromDate || '',
          todate: toDate || '',
          page: pageNo
        }));
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Error completing booking");
    }
  };

  return (
    <div>

      <div className="row g-3">
        {/* Circle */}
        <div className="col-md-2">
          <label className="form-label fw-bold">Circle</label>
          <select
            className="form-control"
            onChange={(e) => {
              setCircle_id(e.target.value);
              setseleceteMangerXenForFilters({});
              setseleceteMangerAenForFilters({});
              setseleceteMangerJenForFilters({});
              setManagerKey(k => k + 1);
              setManagerKeyAen(k => k + 1);
              setManagerKeyJen(k => k + 1);
            }}
          >
            <option value="">Select Circle</option>
            {circles.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>

        {/* XEN */}
        <div className="col-md-2">
          <label className="form-label fw-bold">XEN</label>
          <AsyncPaginate
            key={managerKey}
            value={seleceteMangerXenForFilters}
            loadOptions={loadOptionsgetManagerXenForFilters}
            onChange={(e: any) => {
              setseleceteMangerXenForFilters(e);
              setseleceteMangerAenForFilters({});
              setseleceteMangerJenForFilters({});
              setManagerKeyAen(k => k + 1);
              setManagerKeyJen(k => k + 1);
            }}
            additional={{ page: 1 }}
          />
        </div>

        {/* AEN */}
        <div className="col-md-2">
          <label className="form-label fw-bold">AEN</label>
          <AsyncPaginate
            key={managerKeyAen}
            value={seleceteMangerAenForFilters}
            loadOptions={loadOptionsgetManagerAenForFilters}
            onChange={(e: any) => {
              setseleceteMangerAenForFilters(e);
              setseleceteMangerJenForFilters({});
              setManagerKeyJen(k => k + 1);
            }}
            additional={{ page: 1 }}
          />
        </div>

        {/* JEN */}
        <div className="col-md-2">
          <label className="form-label fw-bold">JEN</label>
          <AsyncPaginate
            key={managerKeyJen}
            value={seleceteMangerJenForFilters}
            loadOptions={loadOptionsgetManagerJenForFilters}
            onChange={(e: any) => {
              setseleceteMangerJenForFilters(e);
              setJenId(e?.value);
              setVehicleKey(k => k + 1);
            }}
            additional={{ page: 1 }}
          />
        </div>

        {/* Vendor */}
        {/* <div className="col-md-2">
          <label className="form-label fw-bold">Vendor</label>
          <AsyncPaginate
            key={`${circle_id}-${seleceteMangerJenForFilters?.id || 'no-jen'}`}
            loadOptions={loadOptionsVendor}
            onChange={(e: any) => {
              setVendorId(e?.value);
              setVehicleKey(k => k + 1);   // 🔥 force vehicle reload
            }}
            additional={{ page: 1 }}
          />
        </div> */}
      </div>
      <VehicleForm
        onSubmit={handleSubmit}
        // vendorId={vendorId}
        jenId={jenId}
        vehicleKey={vehicleKey}
      />
      {vehicle && <VehicleDetailsCard vehicle={vehicle} />}
      <BookingTabs
  activeTab={activeTab}
  setActiveTab={(tab: string) => {
    setActiveTab(tab);
    setPageNo(1);

    // Clear selected bookings when changing tab
    setSelectedBookingIds([]);
  }}
  vehicleId={vehicle?.value}
  bookings={bookings}
  onEditClick={handleEditClick}

  // Bulk booking
  selectedBookingIds={selectedBookingIds}
  onBookingSelection={handleBookingSelection}
  onSelectAllBookings={handleSelectAllBookings}
  allCurrentPageSelected={allCurrentPageSelected}
  onBulkComplete={handleOpenBulkModal}
/>

      {/* Pagination */}
      {pageCount > 1 && (
        <div className="mt-4">
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            pageCount={pageCount}
            previousLabel="< previous"
            forcePage={pageNo - 1}
            containerClassName="pagination justify-content-center"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            activeClassName="active"
          />
        </div>
      )}

      <Modal show={showEditModal} onHide={handleCloseEditModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Customer Name</label>
              <input
                className="form-control"
                value={selectedBooking?.user?.name || ''}
                disabled
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Mobile Number</label>
              <input
                className="form-control"
                value={selectedBooking?.user?.mobile || ''}
                disabled
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Trip Accepted At</label>
              <input
                type="datetime-local"
                className="form-control"
                value={acceptedTime}
                onChange={(e) => setAcceptedTime(e.target.value)}
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Trip End</label>
              <input
                type="datetime-local"
                className="form-control"
                value={completeTime}
                onChange={(e) => setCompleteTime(e.target.value)}
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Select Date</label>
              <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                showTimeSelect
                className="form-control"
                dateFormat="MMMM d, yyyy h:mm aa"
                placeholderText="Select date and time"
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Source</label>
              <AsyncPaginate
                value={selectedSource}
                loadOptions={loadOptionsgetManagerJen}
                onChange={(option: any) => setSelectedSource(option)}
                additional={{ page: 1 }}
                className="form-control"
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Vehicle</label>
              <AsyncPaginate
                value={selectedVehicle}
                loadOptions={loadOptionsgetManagerVehicle}
                onChange={(option: any) => setSelectedVehicle(option)}
                additional={{ page: 1 }}
                className="form-control"
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Destination</label>
              <AsyncPaginate
                value={selectedDestination}
                loadOptions={loadOptionsgetManagerUser}
                onChange={(option: any) => setSelectedDestination(option)}
                additional={{ page: 1 }}
                className="form-control"
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Total Distance(ONE WAY)</label>
              <input
                className="form-control"
                value={totalDistance || ''}
                disabled
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Filling Image</label>
              <input
  type="file"
  accept="image/*"
  onChange={(e) => {
    const file = e.target.files?.[0] || null;

    if (file) {
      handleImagePreview(file, "fillingImage");
    }
  }}
  className="form-control"
/>
              {fileStatus.fillingImage && <p className="text-muted">{fileStatus.fillingImage}</p>}
              {previewImage.fillingImage && (
  <img
    src={previewImage.fillingImage}
    alt="Filling"
    style={{
      width: '100px',
      height: '100px',
      objectFit: 'cover',
      cursor: 'pointer',
      border: '1px solid #ddd'
    }}
    onClick={() => {
      setSelectedImage(previewImage.fillingImage);
      setShowImageModal(true);
    }}
  />
)}
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Destination Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files?.[0] || null;
                  if (file) setDestinationImage(file);
                }}
                className="form-control"
              />
              {fileStatus.destinationImage && <p className="text-muted">{fileStatus.destinationImage}</p>}
              {previewImage.destinationImage && <img src={previewImage.destinationImage} alt="Destination" style={{ width: '100px', height: '100px', objectFit: 'cover' }} />}
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Filling Video</label>
              <input
                type="file"
                accept="video/*"
                onChange={(e) => {
                  const file = e.target.files?.[0] || null;
                  if (file) setFillingVideo(file);
                }}
                className="form-control"
              />
              {fileStatus.fillingVideo && <p className="text-muted">{fileStatus.fillingVideo}</p>}
              {previewImage.fillingVideo && <video controls src={previewImage.fillingVideo} style={{ width: '100px', height: '100px', objectFit: 'cover' }} />}
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label fw-semibold">Destination Video</label>
              <input
                type="file"
                accept="video/*"
                onChange={(e) => {
                  const file = e.target.files?.[0] || null;
                  if (file) setDestinationVideo(file);
                }}
                className="form-control"
              />
              {fileStatus.destinationVideo && <p className="text-muted">{fileStatus.destinationVideo}</p>}
              {previewImage.destinationVideo && <video controls src={previewImage.destinationVideo} style={{ width: '100px', height: '100px', objectFit: 'cover' }} />}
            </div>
          </div>
          <div className="pt-3 text-center">
            <Button variant="light" className="me-3" onClick={handleCloseEditModal}>
              Discard
            </Button>
            <Button variant="primary" onClick={handleBooking}>
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
  show={showImageModal}
  onHide={() => setShowImageModal(false)}
  centered
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>Image Preview</Modal.Title>
  </Modal.Header>

  <Modal.Body className="text-center">
    <img
      src={selectedImage}
      alt="Preview"
      style={{
        maxWidth: '100%',
        maxHeight: '80vh'
      }}
    />
  </Modal.Body>
</Modal>
{/* ==================== BULK COMPLETE BOOKING MODAL ==================== */}

<Modal
  show={showBulkModal}
  onHide={handleCloseBulkModal}
  centered
  size="lg"
>
  <Modal.Header closeButton={!bulkSubmitting}>
    <Modal.Title>
      Complete Bulk Booking
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>

    <div className="alert alert-info">
      <strong>
        {selectedBookingIds.length}
      </strong>{' '}
      booking(s) selected.
    </div>


    <div className="row">

      {/* Vehicle */}
      <div className="mb-3 col-md-6">
        <label className="form-label fw-semibold">
          Vehicle
        </label>

        <input
          type="text"
          className="form-control"
          value={vehicle?.label || ''}
          disabled
        />
      </div>


      {/* Date */}
      <div className="mb-3 col-md-6">
        <label className="form-label fw-semibold">
          Complete Date
        </label>

        <DatePicker
          selected={bulkDate}
          onChange={(date: any) =>
            setBulkDate(date)
          }
          showTimeSelect
          className="form-control"
          dateFormat="MMMM d, yyyy h:mm aa"
          placeholderText="Select date and time"
          disabled={bulkSubmitting}
        />
      </div>


      {/* Selected IDs */}
      <div className="mb-3 col-12">

        <label className="form-label fw-semibold">
          Selected Booking IDs
        </label>

        <div
          className="form-control"
          style={{
            minHeight: '70px',
            height: 'auto',
            backgroundColor: '#f8f9fa',
          }}
        >
          {selectedBookingIds.join(', ')}
        </div>

      </div>


      {/* Filling Image */}
      <div className="mb-3 col-md-6">

        <label className="form-label fw-semibold">
          Filling Image
        </label>

        <input
          type="file"
          accept="image/jpeg,image/jpg,image/png"
          className="form-control"
          disabled={bulkSubmitting}
          onChange={(e) => {

            const file =
              e.target.files?.[0] || null;

            if (!file) {
              setBulkFillingImage(null);
              return;
            }

            if (!file.type.startsWith('image/')) {
              toast.error(
                'Please select a valid image'
              );

              e.target.value = '';
              return;
            }

            if (file.size > 5100 * 1024) {
              toast.error(
                'Filling image must be smaller than 5.1 MB'
              );

              e.target.value = '';
              return;
            }

            setBulkFillingImage(file);
          }}
        />

        {bulkFillingImage && (
          <small className="text-success d-block mt-1">
            Selected: {bulkFillingImage.name}
          </small>
        )}

      </div>


      {/* Destination Video */}
      <div className="mb-3 col-md-6">

        <label className="form-label fw-semibold">
          Destination Video
        </label>

        <input
          type="file"
          accept="video/mp4,video/mpeg,video/quicktime,video/3gp,video/3gpp"
          className="form-control"
          disabled={bulkSubmitting}
          onChange={(e) => {

            const file =
              e.target.files?.[0] || null;

            if (!file) {
              setBulkDestinationVideo(null);
              return;
            }

            const allowedTypes = [
              'video/mp4',
              'video/mpeg',
              'video/quicktime',
              'video/3gp',
              'video/3gpp',
            ];

            if (!allowedTypes.includes(file.type)) {
              toast.error(
                'Please select a valid destination video'
              );

              e.target.value = '';
              return;
            }

            setBulkDestinationVideo(file);
          }}
        />

        {bulkDestinationVideo && (
          <small className="text-success d-block mt-1">
            Selected: {bulkDestinationVideo.name}
          </small>
        )}

      </div>

    </div>

  </Modal.Body>


  <Modal.Footer>

    <Button
      variant="secondary"
      onClick={handleCloseBulkModal}
      disabled={bulkSubmitting}
    >
      Discard
    </Button>

    <Button
      variant="success"
      onClick={handleCompleteBulkBooking}
      disabled={
        bulkSubmitting ||
        selectedBookingIds.length === 0 ||
        !vehicle?.value ||
        !bulkDate
      }
    >
      {bulkSubmitting
        ? 'Submitting...'
        : `Complete ${selectedBookingIds.length} Booking(s)`}
    </Button>

  </Modal.Footer>

</Modal>
    </div>
  );
}

export default VehicleBooking;







